import React, {useEffect, useState} from 'react';
import StatusBar from '../../../components/status-bar';
import '../styles.scss';

export interface CoveragesProgressBarProps {
  progress: string;
  totalSteps: string;
}

function CoveragesProgressBar({progress, totalSteps}: any) {
  return (
    <div className="coverages-div-bar">
      <StatusBar
        gradient
        className="coverages-progress-bar"
        currentSteps={parseInt(progress)}
        totalSteps={parseInt(totalSteps)}
      />
    </div>
  );
}

export default CoveragesProgressBar;
